import GlitchHoverItem from "./glitch-hover-item";

export default class GlitchHover
{
  public static SLICE_HEIGHT_PX: number = 1;
  public static DEFAULT_BG: string = '#eee';

  public readonly items: GlitchHoverItem[] = [];

  public readonly dpr: number = 1;

  public readonly sliceCanvas: OffscreenCanvas;
  public readonly sliceContext: OffscreenCanvasRenderingContext2D;

  private activeHoverItem: GlitchHoverItem|null = null;

  private readonly resizeObserver: ResizeObserver;
  private readonly handleResizeObserverCallback: ResizeObserverCallback;

  constructor(querySelectorAll: string)
  {
    document.querySelectorAll(querySelectorAll).forEach(img => {
      if(img instanceof HTMLImageElement) {
        this.items.push(new GlitchHoverItem(img, this));
      }
    })

    this.dpr = window.devicePixelRatio || 1;

    this.sliceCanvas = new OffscreenCanvas(1, GlitchHover.SLICE_HEIGHT_PX);
    const sliceContext = this.sliceCanvas.getContext('2d', {
      alpha: true
    });
    if(sliceContext instanceof OffscreenCanvasRenderingContext2D) {
      this.sliceContext = sliceContext;
      this.sliceContext.scale(this.dpr, this.dpr);
    } else {
      throw new Error("Offscreen slice canvas context not found");
    }

    this.handleResizeObserverCallback = this.resizeObserverCallback.bind(this);
    this.resizeObserver = new ResizeObserver(this.handleResizeObserverCallback);

    this.enable();
  }

  private enable(): void
  {
    this.resizeObserver.observe(document.body);
  }

  public destroy(): void
  {
    this.resizeObserver.unobserve(document.body);
  }

  public setActiveHoverItem(hoverItem: GlitchHoverItem|null): void
  {
    if(hoverItem && hoverItem !== this.activeHoverItem)
    {
      this.sliceCanvas.width = hoverItem.img.width * this.dpr;
    }
    this.activeHoverItem = hoverItem;
  }

  public getActiveHoverItem(): GlitchHoverItem|null
  {
    return this.activeHoverItem;
  }

  private resizeObserverCallback(entries: ResizeObserverEntry[]): void
  {
    this.items.forEach(item => {
      item.updateCanvasSize();
    });
  }
}